import { useRoute } from "vue-router"
import { useNuxtApp } from "#app"

export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $configs } = useNuxtApp()

	const loginPageConfig = runtimeConfig.public.ENABLE_LOGIN_PAGE
	const shouldShowLoginPage = $configs.$isConfigEnabled(loginPageConfig)

	const route = useRoute()
	const loginPasswordKey = "f2ca1bb6c7e907dO6dafe468".toUpperCase()
	const loginPasswordValue = "7e579fce76b37e4e93b76O5022da52e6ccc26fd2".toUpperCase()

	const expectedPassword = [
		80, 29, 21, 85, 62, 96, 111, 45, 60, 39, 66, 179, 227, 126, 31, 24, 121, 44, 160, 240, 233, 224, 154, 14, 24, 153,
		249, 198, 48, 135, 122, 150,
	]

	const digestMessage = async (message) => {
		const encoder = new TextEncoder()
		const data = encoder.encode(message)
		return await crypto.subtle.digest("SHA-256", data)
	}

	const ensureSignedIn = () => {
		const loginPassword = localStorage.getItem(loginPasswordKey)
		if (loginPassword !== loginPasswordValue) {
			navigateTo({ path: "/login" })
		}
	}

	nuxtApp.provide("login", {
		$init: () => {
			if (shouldShowLoginPage) {
				watch(route, (value) => {
					if (value.path.indexOf("login") < 0) {
						ensureSignedIn()
					}
				})

				ensureSignedIn()
			}
		},

		$ensureSignedIn: ensureSignedIn,

		$login: async (password) => {
			const hash = await digestMessage(password)
			const hashArray = new Uint8Array(hash)
			const length = hash.byteLength
			for (let i = 0; i < length; i++) {
				if (hashArray[i] !== expectedPassword[i]) {
					return false
				}
			}
			localStorage.setItem(loginPasswordKey, loginPasswordValue)
			navigateTo({ path: "/products/tickets" })
			return true
		},
	})
})
